export default __webpack_public_path__ + "static/media/splash-screen.a38389fe.png";